import React from 'react';
import PropTypes from 'prop-types';

import RadioGroup from "core/gd-components/gd-radio-group/gd-radio-group-ui5";
import NewViewTemplateSaveTypeNew from "./new/new-view-template-new";
import NewViewTemplateSaveTypeOverride from "./override/new-view-template-override";

export default class NewViewTemplateModal extends React.Component {

    static propTypes = {
        name: PropTypes.string,
        access: PropTypes.string,
        viewSystemType: PropTypes.any,

        isEditTemplate: PropTypes.bool,

        onSubmit: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.state = {
            saveType: 'new'
        }
    }

    onSelectSaveType = (value) => {
        this.setState({
            saveType: value
        })
    }

    render() {
        const saveOptions = [
            {value: 'new',      label: 'Create new view template'},
            {value: 'override', label: 'Override existing'}
        ]

        return (
            <div className="gd-form-modal-new">

                {!this.props.isEditTemplate &&
                <div className="tbl">
                    <div className="row">
                        <div className="label top">Save type</div>
                        <div className="element">
                            <RadioGroup items={saveOptions}
                                        value={this.state.saveType}
                                        onChange={this.onSelectSaveType}/>
                        </div>
                    </div>
                </div>}

                {this.state.saveType === 'new' &&
                    <NewViewTemplateSaveTypeNew {...this.props}/>}

                {this.state.saveType === 'override' &&
                    <NewViewTemplateSaveTypeOverride {...this.props}/>}
            </div>
        );
    }
}